'use strict';

const shipping = require('./shipping');
const address = require('./address');
const progress = require('../../progress');
const prefillAddress = require('../../prefill-address');
const klarna = require('./klarnaGeneral');
const google = require('../../modules/google');
const validator = require('../../validator');
const toaster = require('../../toaster');
const flyout = require('../../flyout');
const ritualsStyles = require('../../rituals-styles');
const fillAddressFields = require('../../modules/util/fillAddressFields');
const formHelpers = require('../../rituals-form-helper');
const customSelect = require('../../select-custom');
//const miniCart = require('../../minicart');
const ritualsFormHelper = require('../../rituals-form-helper');
const isSmallView = require('../../modules/helpers/isSmallView');
const giftwrap = require('../../giftwrap');
const getCountryFromLocaleCookie = require('../../modules/util/getCountryFromLocaleCookie');
const checkoutPostalCode = require('./checkoutPostalCode');
const damHelper = require('../../dam/dam-helper');

const SinglePageCheckout = function () {
    const $step1 = $('.js-step-1');
    const $step1Content = $('.js-step-1-content');
    const $step2 = $('.js-step-2');
    const $step2Content = $('.js-step-2-content');
    const $step3 = $('.js-step-3');
    const $step3Content = $('.js-step-3-content');
    let $currentStep;
    const genericFlyout = '.js-generic-flyout';
    const stickyButtonSelector = '.js-checkout-sticky-button';
    let $addressChanged = false;
    let $previousRadioButton = $('.js-option-radio:checked');
    const stepBtns = {
        step1 : {
            label: Resources.CHECKOUT_GO_TO_STEP_2_LABEL,
            class: 'js-step-1-continue-btn'
        },
        step2 : {
            label: Resources.CHECKOUT_GO_TO_STEP_3_LABEL,
            class: 'js-step-2-continue-btn'
        },
        step3 : {
            label: Resources.CHECKOUT_GO_TO_PAYMENT_LABEL,
            class: 'js-step3-submit'
        }
    };

    const step2KeyPressHandler = function (e) {
        // trigger the next step button on second step while pressing enter key if it is not focused on zip code field
        if (e.which === 13) {
            $('.js-step-2-continue-btn').trigger('click');
        }
    };
    let animationSpeed = 0;

    function updateStickyButton(stepNumber) {
        const $checkoutStickyButton = $(stickyButtonSelector);
        const currentButtonClass = stepBtns[stepNumber].class;
        const currentButtonLabel = stepBtns[stepNumber].label;
        const $spinner = $('.js-spinner-general', $checkoutStickyButton);

        $checkoutStickyButton.data('triggering-action', currentButtonClass);
        $checkoutStickyButton.text(currentButtonLabel);
        $checkoutStickyButton.append($spinner);
    }

    function validateEurobounsField($inputElement){
        $('.js-eurobonus-dropdown').removeClass('eurobonus-valid');
        if ($inputElement.valid()) {
            if ($inputElement.val().length == 0) {
                $inputElement.addClass('error');
                $('#eurobonusError').removeClass('hide').text($inputElement.data('required-text'));
                return false;
            }

            validateEurobonusMemberId($inputElement.val(), null, function(){
                $inputElement.focus();
            });
        }
        return false;
    }

    function initAddressSpecificFields(parentElement, preselectedValues) {
        const country = $('[id$=_country]', parentElement).val();
        if (typeof country !== 'undefined' && country.toLowerCase() !== 'hk') {
            return Promise.all([]);
        }

        const cityField = $('[id$=_addressFields_city]', parentElement);
        const districtField = $('[id$=_addressFields_district]', parentElement);
        const subdistrictField = $('[id$=_addressFields_subdistrict]', parentElement);

        return ritualsFormHelper.initTownDistrictFields(cityField, districtField, subdistrictField, preselectedValues);
    }

    function init() {
        // Make the content containers available from the headers by adding a content property
        $step1.content = $step1Content;
        $step2.content = $step2Content;
        $step3.content = $step3Content;

        shipping.init();
        shipping.initPickupEvents();
        shipping.initUpdatingShippingInformation(updateDeliveryReview);
        prefillAddress.init();
        checkoutPostalCode.initSearchByPostalCode();
        address.init();

        // init js for toaster messages and custom selects
        toaster.init();
        customSelect.init();

        $currentStep = $step1;

        if (pageContext.openStep && pageContext.openStep > 1) {
            window.history.replaceState({'step': pageContext.openStep}, 'step ' + pageContext.openStep, window.location.href);
            showStep(pageContext.openStep);
        } else {
            window.history.replaceState({'step': 1}, 'step 1', window.location.href);
            $(document).trigger('shippingPostalCode.updated', [$('input[name$=_singleshipping_shippingAddress_addressFields_postal]', $step1.content)]);
        }

        initEventsForSetStateFromPostalCode();

        $(document).on('checkout.onHomeDeliveryTimeChange', function () {
            const $flyoutAddressForm = $('.js-edit-delivery-time-wrapper .js-shipping_address_form');
            const $homeDeliveryRadioButton = $('.js-shipping-option-radio');
            setShippingOptionToAddressForm($homeDeliveryRadioButton, $('.js-shipping_address_form', $(genericFlyout)));
            if ($flyoutAddressForm.length) {
                openFlyout($homeDeliveryRadioButton, '.js-edit-delivery-time-wrapper');
                google.places.init(); //Init google places to enable address search field in flyout
                validator.init();
                formHelpers.initializeDataMask();
                checkoutPostalCode.initSearchByPostalCode();
                const $addressForm = $('.js-flyout-content > div').find('.js-checkout-form');
                address.init($addressForm);
                return;
            }

            $('.js-edit-delivery-form').trigger('submit');
        });

        $(document).on('submit', '#find-pickup-postalcode-form', function (e) {
            e.preventDefault();

            const $form = $(this);
            const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

            if ($postalCodeElement.val() === $form.data('current-postal-code')) {
                return;
            }

            if (!$form.valid()) {
                return;
            }

            const $pickupPointFlyoutStoresWrapper = $('.js-pickup-options-wrapper', '.js-flyout-content');

            const ajaxOptions = {
                url: $form.attr('action'),
                data: $form.serialize() + '&dwfrm_cart_searchByPostalCode=searchByPostalCode',
                type: 'POST',
                success: function(result) {
                    const $flyoutView = $(result);
                    $pickupPointFlyoutStoresWrapper.replaceWith($('.js-pickup-options-wrapper', $flyoutView));
                    validator.init();
                    formHelpers.initializeDataMask();
                }
            };

            $.ajax(ajaxOptions);
            return;
        });

        $(document).on('submit', '#find-stores-postalcode-form', function (e) {
            e.preventDefault();

            const $form = $(this);
            const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

            if ($postalCodeElement.val() === $form.data('current-postal-code')) {
                return;
            }

            if (!$form.valid()) {
                return;
            }

            const $pickupInStoreFlyoutStoresWrapper = $('.js-pickup-options-wrapper', '.js-flyout-content');

            const ajaxOptions = {
                url: $form.attr('action'),
                data: $form.serialize() + '&dwfrm_cart_searchByPostalCode=searchByPostalCode',
                type: 'POST',
                success: function(result) {
                    const $flyoutView = $(result);
                    $pickupInStoreFlyoutStoresWrapper.replaceWith($('.js-pickup-options-wrapper', $flyoutView));
                    validator.init();
                    formHelpers.initializeDataMask();
                }
            };

            google.places.init();
            google.places.getLatLongFromPostalCode($postalCodeElement.val(), getCountryFromLocaleCookie(), function (latitude, longitude) {
                ajaxOptions.data += '&latitude=' + latitude + '&longitude=' + longitude;
                $.ajax(ajaxOptions);
            });
            return;
        });

        $(document).on('click', '#btnEditOrderSummary', google.tagManager.pushCheckoutEditOrderSummaryEvent);
        $(document).on('click', '#btnEditShippingAddress', google.tagManager.pushCheckoutDeliveryAddressChangeEvent);
        $(document).on('click', '#btnChangeShippingAddressDetails', google.tagManager.pushCheckoutAddressDetailsChangeEvent);
        $(document).on('click', 'div.checkout__header.step-1', google.tagManager.pushCheckoutBackToDetailsEvent);
        $(document).on('click', '.js-step-1-continue-btn', submitInformationForm);
        $(document).on('click', '.js-change-delivery-details-btn', changeDeliveryDetails);
        $(document).on('click', '.js-change-billing-details-btn', changeBillingDetails);
        $(document).on('click', stickyButtonSelector, bindStickyButtonClick);

        $(document).on('click', '.js-gotostep1', function(e) {
            e.preventDefault();
            if ($currentStep != $step1) {
                openStep(1);
            } else {
                $('html, body').animate({scrollTop: 0}, 'slow');
            }

            $('.js-step-1-spinner').removeClass('spinner-visible');
            $('.js-step-1-continue-btn').removeClass('button-loading');
            $(stickyButtonSelector).removeClass('button-loading');
        });

        $(document).on('click', '.js-gotostep1billing', function (e) {
            e.preventDefault();
            if ($currentStep != $step1) {
                openStep(1);
            }
            // buffer it with 6 yo
            $('html, body').animate({
                scrollTop: $('.js-billing-title').offset().top - $('header').height() - 6
            }, 'slow');
        });

        $(document).on('click', '[id$=sasEurobonusMember]', updateEuroBonusInputField);

        $(document).on('keypress input copy', '#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode', function (e) {
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                return false;
            }

            const $this = $(this);
            const memberCode = $this.val();
            const maxLength = parseInt($this.attr('maxlength'));


            if (memberCode.length >= maxLength) {
                $this.val(memberCode.substr(0, maxLength));
            }

            $('#eurobonusError').addClass('hide').text('');
        });

        $(document).on('change', '#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode', function () {
            $('#validatedEurobonusCode').val('');
        });

        $(document).on('focusout', '#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode', function () {
            const $memberCode = $(this);
            validateEurobounsField($memberCode);
        });

        $(document).on('change', '#dwfrm_billing_paymentMethods_birthday', fillHiddenDobFields);
        $(document).on('change', 'input[name=\'brandCode\']', paymentMethodChanged);
        $(document).on('change', 'select[name=\'issuerId\']', idealBankChanged);
        $(document).on('click', '.js-step3-submit', pay);
        // trigger the step 2 button by clicking the stickybar button
        $(document).on('click', '.js-checkout-sticky-button.js-step-2-continue-btn', function () {
            $('.step2-bottom-button .js-step-2-continue-btn').click();
        });
        // Enable animations after the page has loaded
        animationSpeed = 400;

        // Swedish Social Number
        if ($('input[id$=addressFields_ssn]').length > 0) {
            klarna.init();
        }

        $(document).on('change.all', '#shipping_address_form input, #shipping_address_form select', function () {
            if ($(this).closest('.js-company-fields').length) {
                const $billingForm = getBillingForm();
                updateAddressSummary($billingForm);
                return;
            }
            updateAddressSummary();
            $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').closest('div').removeClass('hide');
        });

        $(document).on('change.all', '#billing_address_form input, #billing_address_form select, #company_details_form input, #company_details_form select', function () {
            const $billingForm = getBillingForm();
            updateAddressSummary($billingForm);
        });

        $(document).on('change.all', '[id$=useAsBillingAddress]', function () {
            if (!$(this).is(':checked')) {
                const $billingForm = getBillingForm();
                updateAddressSummary($billingForm);
                return;
            }
            updateAddressSummary();
            $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').closest('div').removeClass('hide');
        });

        function checkIsNifChecked() {
            const $form = $('.js-generic-flyout');
            const $input = $form.find('input[id$=nifNumber]');
            const $fieldWrapper = $input.parent();
            const $addNifNumber = $form.find('input[id$=addNifNumber]');

            if (!$addNifNumber.is(':checked')) {
                $fieldWrapper.css('display', 'none');
            }
        }

        $(document).on('click', '.js-review-edit-address', function () {
            openFlyout(this, '.js-edit-delivery-details-wrapper');
            checkIsNifChecked();
            google.places.init(); //Init google places to enable address search field in flyout
            validator.init();
            formHelpers.initializeDataMask();
            checkoutPostalCode.initSearchByPostalCode();
            const $addressForm = $('.js-flyout-content > div').find('.js-checkout-form');
            address.init($addressForm);

            const preselectedValues = {
                city: $('input[name="preselected-shipping-city"]').val() || '',
                district: $('input[name="preselected-shipping-district"]').val() || '',
                subdistrict: $('input[name="preselected-shipping-subdistrict"]').val() || ''
            };

            const $genericFlyout = $('.js-generic-flyout');
            initAddressSpecificFields($genericFlyout, preselectedValues).then(() => updateAddressSummary());
        });

        $(document).on('click', '.js-review-edit-billing', function () {
            openFlyout(this, '.js-edit-billing-details-wrapper');
            checkIsNifChecked();
            google.places.init();
            validator.init();
            formHelpers.initializeDataMask();
            const $addressForm = $('.js-flyout-content > div').find('.js-billing-form');
            address.init($addressForm);

            const preselectedValues = {
                city: $('input[name="preselected-billing-city"]').val() || '',
                district: $('input[name="preselected-billing-district"]').val() || '',
                subdistrict: $('input[name="preselected-billing-subdistrict"]').val() || ''
            };

            const $genericFlyout = $('.js-generic-flyout');
            initAddressSpecificFields($genericFlyout, preselectedValues).then(() => updateAddressSummary($addressForm));
        });


        $(document).on('submit', '.js-edit-delivery-form', function(evt) {
            evt.preventDefault();
            const form = $(this);
            const page = 'checkout_page';
            const defaultOption = $('.js-shipping-option-radio').data('default-option');

            giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $previousRadioButton, function() {
                const submit = $('button[type=submit]', form);
                const spinner = $('.js-update-delivery-time-spinner', submit);
                submit.addClass('btn--disabled');
                submit.addClass('button-loading');
                spinner.addClass('spinner-visible');
                updateDeliveryTimeFlyout(form, evt);
            });
        });

        function updateDeliveryTimeFlyout(form, evt) {
            const addressForm = $('.js-shipping_address_form', form);
            const selectedOption = $('.js-scheduled-home-delivery-select option:selected');

            if (addressForm.length === 0) { //No address form, update only the option
                updateShippingOption(selectedOption);
                return;
            }

            setShippingOptionToAddressForm(selectedOption, addressForm);
            submitInformationForm(evt, flyout.closeFlyouts, addressForm.closest('form'));
        }

        $(document).on('mousedown', '.js-shipping-option-radio-label', function () {
            $previousRadioButton = $('.js-option-radio:checked');
        });

        $(document).on('click', '.js-checkout-radio [name=shippingoption]', function(evt) {
            const $this = $(this);
            $addressChanged = true;

            if ($this.hasClass('js-shipping-option-radio')) {
                const $flyoutAddressForm = $('.js-edit-delivery-time-wrapper .js-shipping_address_form');
                if ($flyoutAddressForm.length > 0) { //This option requires setting the address form, let's show it right away
                    evt.preventDefault();
                    openFlyout(this, '.js-edit-delivery-time-wrapper');
                    setShippingOptionToAddressForm($this, $('.js-shipping_address_form', $(genericFlyout)));
                    google.places.init(); //Init google places to enable address search field in flyout
                    validator.init();
                    formHelpers.initializeDataMask();
                    checkoutPostalCode.initSearchByPostalCode();
                    return;
                }
            }

            updateShippingOption($this);
        });

        $(document).on('change', 'select[name$=_addressList]', function(e){
            e.preventDefault();

            const $this = $(this);
            const $addressForm = $this.parents('.js-address-form');
            const $selected = $this.children(':selected').first();

            const selectedAddress = $selected.data('address');
            if (!selectedAddress) {
                return;
            }

            fillAddressFields(selectedAddress, $addressForm);
            updateAddressSummary($addressForm);

            const $addToAddressBook = $addressForm.find('[id$=addToAddressBook]');
            if ($addToAddressBook.length > 0) {
                $addToAddressBook.prop('checked', false);
                $addToAddressBook.closest('div').addClass('hide');
            }

            $addressForm.find('[name$=salutation]').selectric('refresh');

            // re-validate the form
            $addressForm.valid();
        });

        $(document).on('input copy', 'div.js-flyout-container input[name$="_address1"]', function(){
            const avataxErrorMessageDivEl = $('div.js-avatax-address-validation-error');
            if (avataxErrorMessageDivEl && avataxErrorMessageDivEl.parents('div.js-flyout-container').length) {
                avataxErrorMessageDivEl.addClass('hide');
            }
        });

        setupBackButtonHistoryFunctionality();

        google.tagManager.bindFormFieldErrorEvents();

        //miniCart.adjustPricePadding();
        adjustPricePadding();

        let addressForm = $('#shipping_address_form');
        const isBillingAddress = $('.js-billing-address-holder').length > 0;

        if (isBillingAddress) {
            addressForm = $('#billing_address_form');
        }

        updateAddressSummary(addressForm);

        const $shippingAddressForm = $('#shipping_address_form');
        const $billingAddressForm = $('#billing_address_form');

        initAddressSpecificFields($shippingAddressForm);
        initAddressSpecificFields($billingAddressForm);
    }

    function setShippingOptionToAddressForm(shippingOption, form){
        const field = $('[id$=deliveryOption]', form);

        if (!shippingOption.length) {
            field.val(null);
        }

        const deliveryOption = {
            shippingOptionId: shippingOption.data('shipping-option-id') || null,
            shippingService: shippingOption.data('shipping-service') || null
        };

        field.val(JSON.stringify(deliveryOption));
    }

    function setupBackButtonHistoryFunctionality() {
        $(document).on('click', '.js-checkout-back', function() {
            window.history.back();
            $('html, body').animate({scrollTop: 0});
        });

        $(window).on('popstate', function(e) {
            const state = e.originalEvent.state;

            if (state && Object.prototype.hasOwnProperty.call(state, 'step')) {
                openStep(state.step, true);
                return;
            }

            openStep(1, true);
        });
    }

    function adjustPricePadding() {
        $('.js-minicart-product').each(function () {
            const $this = $(this);
            const smallTitle = '.js-mini-cart-small-title';
            const $price = $this.find('.js-mini-cart-price-wrapper');

            if ($this.find(smallTitle).length) {
                const smallTitleHeight = $(smallTitle).outerHeight() + 5;

                $price.css('padding-top', smallTitleHeight);
            } else {
                $price.css('padding-top', 0);
            }
        });
    }

    $(document).on('change', '.js-service-point-postnummer-input', function(){
        const dHLPostNummer = $(this).val();
        setHiddenDHLPostNummer(dHLPostNummer);
    });

    function changeDeliveryDetails(e){
        e.preventDefault();
        const $form = $(this).closest('form');
        $form.find('.js-service-point-postnummer-input-error').addClass('hide');
        const accountNumberInput = $form.find('.js-service-point-postnummer-input');
        //if paazl distributor is DHL germany, service points are selected and accountnumber field exists, validate input first
        if (!accountNumberInput.length) {
            submitInformationForm(e, flyout.closeFlyouts, $form);
            return;
        }

        $.ajax({
            type: 'GET',
            url: Urls.checkoutCheckAccountServiceNumberForPaazl,
            data: {
                accountServiceNumber: accountNumberInput.val()
            },
            success: function (data) {
                if (data.valid) {
                    setHiddenDHLPostNummer(accountNumberInput.val());
                    submitInformationForm(e, flyout.closeFlyouts, $form);
                } else {
                    $form.find('.js-service-point-postnummer-input-error').removeClass('hide');
                }
            }
        });
    }

    function changeBillingDetails(e) {
        e.preventDefault();

        const $billingForm = $('.js-flyout-container .js-billing-form');
        const isBillingFormValid = $billingForm.validate().checkForm();

        if (isBillingFormValid) {
            const $spinner = $billingForm.find('.js-step-1-spinner');
            $spinner.parent().addClass('button-loading');
            $spinner.addClass('spinner-visible');

            $.ajax({
                url: $billingForm.attr('action'),
                data: $billingForm.serialize() + '&dwfrm_billing_save=save',
                type: 'POST',
                success: function (result) {
                    const location = getRedirectLocationFromResult(result);
                    if (location) {
                        window.location = result.location;
                        return;
                    }

                    if (result.Errors) {
                        fillValidationFailsFromBE(result.Errors, $billingForm);
                        return;
                    }

                    updateStep2(true);
                    $addressChanged = true;

                    flyout.closeFlyouts();
                },
                complete: function() {
                    $spinner.parent().removeClass('button-loading');
                    $spinner.removeClass('spinner-visible');
                },
                statusCode: {
                    401: function(data) {
                        window.location = data.getResponseHeader('Location');
                    }
                }
            });
        } else {
            $billingForm.valid();
            return false;
        }
    }

    function bindStickyButtonClick(e){
        const stepButtonClass = $(e.target).data('triggering-action');
        $('.' + stepButtonClass).click();
    }

    function getRedirectLocationFromResult(result) {
        if (result !== undefined && result !== null &&
            result.location !== undefined &&
            result.location !== null) {
            return result.location;
        }

        return null;
    }

    function updateEuroBonusInputField() {
        const $eurobonusBlock = $('.js-eurobonus-dropdown');
        const isChecked = $('[id$=sasEurobonusMember]').is(':checked');

        if (isChecked) {
            $eurobonusBlock.removeClass('hide');
        } else {
            $eurobonusBlock.addClass('hide');
        }
    }

    function updateShippingOption(selectedOptionElement) {
        if (selectedOptionElement.length === 0) {
            return;
        }

        const page = 'checkout_page';
        const shippingOptionId = selectedOptionElement.data('shipping-option-id');
        const pickupPointCode = selectedOptionElement.data('service-point-code');
        const shippingService = selectedOptionElement.data('shipping-service');
        const defaultOption = selectedOptionElement.data('default-option');

        const dHLPostNummer = selectedOptionElement.hasClass('js-pickup-option-radio') ? $('.js-service-point-postnummer-input').val() : null;

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $previousRadioButton, function() {
            shipping.updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, dHLPostNummer, function(response) {
                handleUpdateShippingInformationResponse(response.selectedShippingOption, dHLPostNummer);
            }, defaultOption, null, page);
        });
    }

    function handleUpdateShippingInformationResponse(selectedShippingOption, dHLPostNummer) {
        $addressChanged = true;
        if (selectedShippingOption.exclusionResult) {
            window.location.href = Urls.cartShow;
            return true;
        }
        updateStep2(true);
        if (dHLPostNummer) {
            setHiddenDHLPostNummer(dHLPostNummer);
        }
        flyout.closeFlyouts();
        updateOrderTotals(selectedShippingOption.totalPrice);
    }

    function openFlyout(originalElement, flyoutHtmlSelector) {
        $('.js-service-point-postnummer-input-error').addClass('hide');
        $(genericFlyout).addClass('change-delivery-flyout');

        const options = {
            open: function() {
                formHelpers.init();
                const $flyoutDropdown = $('.js-generic-flyout').find('.js-custom-select');
                $flyoutDropdown.selectric();
                if (!isSmallView()) {
                    $flyoutDropdown.attr('tabindex', '-1');
                }
            }
        };

        const flyoutHtml = $(flyoutHtmlSelector).html();
        flyout.loadFromHtml(flyoutHtml, options);

        $(originalElement).addClass('js-triggered-flyout');

        initEventsForSetStateFromPostalCode();

        $('[name$="_addToAddressBook"]').prop('checked', false);
        $('[name$="_addToAddressBook"]').change(function() {
            const isChecked = $(this).is(':checked');
            const $el = $('[name$="_addToAddressBook"]');
            $el.prop('checked', isChecked);
        });
    }

    function initEventsForSetStateFromPostalCode() {
        const $countries = $('[id$=_country]');

        $countries.each(function() {
            const $country = $(this);

            if ($country.val() === 'US') {
                const $postalCodeEl = $country.closest('fieldset').find('[id$=_postal]');

                $postalCodeEl.on('blur keydown', google.places.setStateFromPostalCode);
                $postalCodeEl.on('keydown.country, change.country',function(){
                    $postalCodeEl.data('changed', true);
                });

                google.places.setStateIDDataForPostalCode();
            }
        });
    }

    function setStateFromPostalCode(callback) {
        if (!callback || !$.isFunction(callback)) {
            return false;
        }

        const countryPromises = [];
        const $countries = $('[id$=_country]');

        $countries.each(function() {
            const $country = $(this);

            if ($country.val() !== 'US') {
                return;
            }

            const $postal = $country.closest('fieldset').find('[id$=_postal]');

            if (!$postal.data('changed')) {
                return;
            }

            $postal.data('state-id', '');

            countryPromises.push(new Promise(function(resolve) {
                const postalCode = $postal.val();
                const $stateUS = $postal.closest('fieldset').find('[id$=_stateUS]');

                google.places.getStateFromPostalCode(postalCode, $country.val(), function (state) {
                    $stateUS.val(state || '');
                    $stateUS.selectric('refresh');
                    $postal.data('state-id', state);
                    $postal.data('changed', false);
                    $stateUS.valid();

                    resolve();
                });
            }));
        });

        return Promise.all(countryPromises)
            .then(callback);
    }

    function fillHiddenDobFields() {
        const $day = $('#dwfrm_billing_paymentMethods_birthDayDay');
        const $month = $('#dwfrm_billing_paymentMethods_birthDayMonth');
        const $year = $('#dwfrm_billing_paymentMethods_birthDayYear');

        const values = $(this).val().split('/');
        $day.val(values[0]);
        $month.val(values[1]);
        $year.val(values[2]);
    }

    /**
     * @function
     * @description this will submit the shipping / billing form information and continue with step 2
     *
     * @param {any} e event object
     */
    function submitInformationForm(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink) {
        e.preventDefault();

        const country = $('[id$=_country]').val();
        if (country !== 'US') {
            return internalSubmitInformation(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink);
        }

        return setStateFromPostalCode(function(){
            internalSubmitInformation(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink);
        });
    }

    function internalSubmitInformation(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink) {
        const avataxErrorMessageDivEl = $('div.js-avatax-address-validation-error');
        if (avataxErrorMessageDivEl) {
            avataxErrorMessageDivEl.addClass('hide');
        }
        if (!checkoutForm) {
            checkoutForm = $(e.target).closest('.js-checkout-form');
        }

        const shippingFormValidation = checkoutForm.validate();
        const validShippingForm = shippingFormValidation ? shippingFormValidation.checkForm() : false;
        const validBillingForm = $('#billing_address_form').validate().checkForm();
        const useSameBillingAddress = $('#checkbox_use_shipping_as_billing').prop('checked');

        const validForm = validShippingForm ? (useSameBillingAddress ? validShippingForm : validBillingForm) : validShippingForm;

        if (!validForm && socialCommerceSendCheckoutLink){
            return false;
        }

        if (!validForm) {
            checkoutForm.valid();
            return false;
        }

        if (e) {
            const redirectTo = $(e.target).data('redirecto');
            if (redirectTo) {
                window.location.href = redirectTo;
                return true;
            }

            const preventSubmit = $(e.target).data('prevent-submit');
            if (preventSubmit) {
                return false;
            }
        }

        const options = {
            url: checkoutForm.attr('action'),
            data: checkoutForm.serialize() + '&dwfrm_singleshipping_shippingAddress_save=save', // triggered action
            type: 'POST',
            success: function (result) {
                if (socialCommerceSendCheckoutLink) {
                    socialCommerceSendCheckoutLink($(e.target), 1);
                    return;
                }
                if (result.location && !result.errorMessage) {
                    window.location = result.location;
                    return;
                }
                if (result.errorMessage) {
                    checkoutPostalCode.showPostalCodeErrors($('#dwfrm_singleshipping_shippingAddress_addressFields_postal', checkoutForm),
                    checkoutForm.find('button[type=submit]'), shippingFormValidation, result.errorMessage);
                    checkoutForm.validate();
                    step1ButtonLoading(false);
                    return;
                }
                if (result.addressValidationError) {
                    if (avataxErrorMessageDivEl && avataxErrorMessageDivEl.parents('div.js-flyout-container').length) {
                        $('.js-avatax-address-validation-error-message').html(result.addressValidationError);
                        avataxErrorMessageDivEl.removeClass('hide');
                        step1ButtonLoading(false);
                        return;
                    }

                    $('.js-address-validation-error-text').html(result.addressValidationError);
                    toaster.open({
                        target: $('.js-address-validation-toaster')
                    });
                    step1ButtonLoading(false);
                    return;
                }
                if (!result.valid && result.validationResults) {
                    fillValidationFailsFromBE(result.validationResults, checkoutForm);
                    step1ButtonLoading(false);
                    return;
                }

                updateStep2(false, function() {
                    step1ButtonLoading(false);
                    if (successCallback) {
                        successCallback();
                    }
                });

            },
            statusCode: {
                401: function(data) {
                    window.location = data.getResponseHeader('Location');
                }
            }
        };

        if (!socialCommerceSendCheckoutLink) {
            step1ButtonLoading(true);
        }
        $.ajax(options);
        return true;
    }

    function step1ButtonLoading(turnOn) {
        const $step1ContinueButton = $('.js-step-1-continue-btn');
        const $spinnerStep1 = $('.js-step-1-spinner');

        $step1ContinueButton.toggleClass('button-loading', turnOn);
        $(stickyButtonSelector).toggleClass('button-loading', turnOn);
        $spinnerStep1.parent().toggleClass('button-loading', turnOn);
        $spinnerStep1.toggleClass('spinner-visible', turnOn);
    }

    function fillValidationFailsFromBE(errors, form) {
        const formValidator = form.validate();
        let selector;
        const errorMessages = {};
        for (let i = 0; i < errors.length; i++) {
            if (errors[i].error) {
                if (errors[i].addresstype == 'billingAddress') {
                    if ($('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress').is(':checked')) {
                        $('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress').attr('checked', false).change();
                    }
                    selector = 'dwfrm_billing_' + errors[i].addresstype + '_addressFields_' + errors[i].errorField;
                } else {
                    selector = 'dwfrm_singleshipping_' + errors[i].addresstype + '_addressFields_' + errors[i].errorField;
                }

                errorMessages[selector] = errors[i].reason;
                formValidator.showErrors(errorMessages);
            }
        }
    }

    function updateAddressSummary(addressForm) {
        if (!addressForm) {
            addressForm = getShippingForm();
        }

        const messageFormat = addressForm.find('.js-address-summary-format').val() || '';
        if (messageFormat === '') {
            return;
        }

        const isHomeDeliveryActive = $('.js-shipping-option-radio:checked').length > 0;
        const isBillingAddress = $('.js-billing-address-holder').length > 0;

        const firstName = addressForm.find('input.firstName').val() || '';
        const lastName = addressForm.find('input.lastName').val() || '';
        const phone = addressForm.find('input.phone').val() || '';

        const pickupPointName = $('.js-pickup-point-name').val();
        const pickupPointAddress = $('.js-pickup-point-address').val();
        const pickupPointPostalCode = $('.js-pickup-point-postalcode').val();
        const pickupPointCity = $('.js-pickup-point-city').val();

        const pickupInStoreAddress = $('.js-pickup-in-store-address').val();
        const pickupInStoreTime = $('.js-pickup-in-store-time').val();
        let fullMessage = '';
        if (!isHomeDeliveryActive && !isBillingAddress && pickupPointName && pickupPointAddress && pickupPointPostalCode && pickupPointCity) {
            let dHLPostNummer = '';
            if (addressForm.find('.js-service-point-postnummer-input').length > 0 && addressForm.find('.js-service-point-postnummer-input').data('distributor') === 'DHL_DE') {
                const dHLPostNummerFormat = $('.js-address-dhlpostnummer-format').val() || '';
                dHLPostNummer = String.format(dHLPostNummerFormat, addressForm.find('.js-dhl-post-nummer').val());
            }
            fullMessage = String.format(messageFormat, pickupPointName, firstName, lastName,
                pickupPointAddress, pickupPointPostalCode, pickupPointCity, dHLPostNummer, phone);
        } else if (!isHomeDeliveryActive && !isBillingAddress && pickupInStoreAddress && pickupInStoreTime) {
            fullMessage = String.format(messageFormat, pickupInStoreAddress, pickupInStoreTime);
        } else {
            const preselectedCity = $('input[name="preselected-shipping-city"]').val() || '';

            const street = addressForm.find('input.street').val() || '';
            const houseNumber = addressForm.find('input.houseNumber').val() || '';
            const houseNumberExtension = addressForm.find('input.houseNumberExtension').val() || '';
            const address1 = addressForm.find('input.address1').val() || '';
            const address2 = addressForm.find('input.address2').val() || '';
            const cityFormField = addressForm.find('[id$=_addressFields_city]');
            let city = preselectedCity;
            if (cityFormField.prop('tagName') === 'INPUT') {
                city = cityFormField.val() || preselectedCity;
            } else if (cityFormField.prop('tagName') === 'SELECT') {
                const selectedCity = cityFormField.find('option:selected');
                city = selectedCity.length && selectedCity.prop('index') !== 0 ? selectedCity.text() : '';
            }
            const state = addressForm.find('select.stateUS').val() || '';
            const postalCode = addressForm.find('input.postal').val() || '';
            const country = $(document).find('input.js-country-name').val() || '';
            const phone = addressForm.find('input.phone').val() || '';
            const districtFromField = addressForm.find('select.district');
            const selectedDistrict = districtFromField.find('option:selected');
            let district = selectedDistrict.length && selectedDistrict.prop('index') !== 0 ? selectedDistrict.text() : '';
            const subdistrictFromField = addressForm.find('select.subdistrict');
            const selectedSubdistrict = subdistrictFromField.find('option:selected');
            let subdistrict = selectedSubdistrict.length && selectedSubdistrict.prop('index') !== 0 ? selectedSubdistrict.text() : '';
            district = district !== '' ? ', ' + district : '';
            subdistrict = subdistrict !== '' ? ', ' + subdistrict : '';
            const email = '';
            const stateCode = '';

            const $companyDetailsForm = getCompanyDetailsForm(addressForm);
            const taxIdNumberFormat = addressForm.find('.js-tax-id-number-format').val() || '';
            const companyName = $companyDetailsForm.find('input.companyName').val() || '';
            const cocNumber = $companyDetailsForm.find('input.cocNumber').val() || '';
            const taxIdNumber = $companyDetailsForm.find('input.vatNumber').val() || getNifValue($companyDetailsForm);

            const fullTaxIdNumber = taxIdNumber && taxIdNumber.length > 0 ? String.format(taxIdNumberFormat, taxIdNumber) : '';

            fullMessage = String.format(messageFormat, firstName, lastName,
            street, houseNumber, houseNumberExtension,
            address1, address2, city, state,
            postalCode, country, phone, district, subdistrict,
            email, stateCode,
            companyName, cocNumber, fullTaxIdNumber);
        }

        addressForm.find('.js-address-holder').html(fullMessage);
    }

    function getNifValue(form) {
        if (form.find('input.addNifNumber').is(':checked')) {
            return form.find('input.nifNumber').val();
        }

        return '';
    }

    function getShippingForm() {
        let $addressForm = $('.js-flyout-content > div').find('.js-shipping_address_form');
        if ($addressForm.length === 0) {
            $addressForm = $('.js-step-1-content').find('.js-shipping_address_form');
        }
        return $addressForm;
    }

    function getBillingForm() {
        let $billingForm = $('.js-flyout-content > div').find('.js-billing-form');
        if ($billingForm.length === 0) {
            $billingForm = $('.js-step-1-content').find('.js-billing-address-form');
        }
        return $billingForm;
    }

    function getCompanyDetailsForm(addressForm) {
        if (companyDetailsExists(addressForm)) {
            return addressForm;
        }

        addressForm = getShippingForm();
        if (companyDetailsExists(addressForm)) {
            return addressForm;
        }

        return getCheckoutForm().find('#company_details_form');
    }

    function getCheckoutForm() {
        let $checkoutForm = $('.js-flyout-content > div').find('.js-checkout-form');
        if ($checkoutForm.length === 0) {
            $checkoutForm = $('.js-step-1-content').find('.js-checkout-form');
        }
        return $checkoutForm;
    }

    function companyDetailsExists(addressForm) {
        return addressForm.find('input.cocNumber').length > 0 || addressForm.find('input.companyName').length > 0 || addressForm.find('input.vatNumber').length > 0 || addressForm.find('input.nifNumber').length > 0;
    }

    function processHistoryUpdates(skipHistoryUpdate, stepIndex) {
        if (skipHistoryUpdate === undefined || !skipHistoryUpdate) {
            window.history.pushState({'step': stepIndex}, 'step ' + stepIndex, window.location.href);
        }
    }

    function updateStep1(skipHistoryUpdate) {
        if ($addressChanged) {
            $.ajax({
                type: 'GET',
                url: Urls.checkoutStep1,
                success: function (data) {
                    showStep1(data);

                    ritualsStyles.initInputStyles();
                    jumpToStep($step1, 1, skipHistoryUpdate);
                    $('html, body').delay('fast').animate({scrollTop: 0}, 'fast');

                }
            });
            return;
        }

        $('.js-step-1-spinner').removeClass('spinner-visible');
        $('.js-step-1-continue-btn').removeClass('button-loading')
            .removeClass('button-loading')
            .removeClass('btn-loader');
        $step2.addClass('disabled');
        $step3.addClass('disabled');
        jumpToStep($step1, 1, skipHistoryUpdate);
    }

    function updateStep2(skipHistoryUpdate, onLoadComplete) {
        processHistoryUpdates(skipHistoryUpdate, 2);

        $.ajax({
            type: 'GET',
            url: Urls.checkoutStep2,
            success: function (data) {
                google.tagManager.pushVirtualPage(Urls.checkoutStep2, Resources.CHECKOUT_STEP2_TITLE, 'review');

                showStep2(data);
                updateSummary();

                updateStickyButton('step2');

                if (onLoadComplete) {
                    onLoadComplete();
                }

                ritualsStyles.initInputStyles();
                $('html, body').delay('fast').animate({scrollTop: 0}, 'fast');
            }
        });
    }

    function showStep2(data) {
        $currentStep = $step2;
        $(stickyButtonSelector).removeClass('button-loading');

        $step1.removeClass('current').removeClass('selected');
        $step1.content.removeClass('open').hide();

        $step3.removeClass('current').removeClass('selected');
        $step3.addClass('disabled');
        $step3.content.hide().removeClass('open');

        $step2.addClass('current selected');
        $step2.content.show().addClass('open').prev().addClass('open');

        $step2.removeClass('disabled');

        if (data) {
            $step2.content.html(data);
            customSelect.init();

        }

        shipping.handleNifStep2();
        // copy the regex from the shipping zip code
        const zipcodeRegex = $('#dwfrm_billing_billingAddress_addressFields_postal').attr('regex');
        $('.js-service-point-zipcode-input').attr('regex', zipcodeRegex);

        $(document).on('keydown', '.js-step-2-continue-btn', step2KeyPressHandler);

        $(document).on('click', '.js-checkout-sticky-button', function () {
            $(this).addClass('button-loading');
            $(this).find('.js-spinner-general').addClass('spinner-visible');
        });

        $(document).off('click', '.js-step-2-continue-btn');
        $(document).on('click', '.js-step-2-continue-btn', function () {
            $('.js-service-point-postnummer-input-error').addClass('hide');

        const $shippingOption = $('.js-option-radio:checked');
        const deliveryMethod = $shippingOption.length ? $shippingOption.data('delivery-method-type') : 'unknown';
            google.tagManager.pushDeliveryMethod(deliveryMethod);

            $(this).addClass('button-loading');
            $(this).find('.js-spinner-general').addClass('spinner-visible');

            updateStep3();
        });
    }

    function showStep1(data) {
        $currentStep = $step1;
        $addressChanged = false;
        $(stickyButtonSelector).removeClass('button-loading');

        $step2.removeClass('current').removeClass('selected');
        $step2.addClass('disabled');
        $step2.content.removeClass('open').hide();

        $step3.removeClass('current').removeClass('selected');
        $step3.addClass('disabled');
        $step3.content.hide().removeClass('open');

        $step1.addClass('current selected');
        $step1.content.show().addClass('open').prev().addClass('open');

        if (data) {
            $step1.content.html(data);
            customSelect.init();
            shipping.handleBillingAddressFields();
            shipping.handleNifNumberSection();
        }

        $step1.removeClass('disabled');
    }

    function updateStep3(skipHistoryUpdate) {
        processHistoryUpdates(skipHistoryUpdate, 3);

        const accountNumberInput = $('input.js-dhl-post-nummer');
        $(document).off('keydown', step2KeyPressHandler);

        const checkoutStep3 = {
            type: 'GET',
            url: Urls.checkoutStep3,
            data: {
                openStep: pageContext.openStep,
                paymentStatus: pageContext.paymentStatus,
                paymentMethodID: pageContext.paymentMethodID,
                accountServiceNumber: accountNumberInput.length ? accountNumberInput.val() : null
            },
            success: function (data) {
                updateSummary();
                google.tagManager.pushVirtualPage(Urls.checkoutStep3, Resources.CHECKOUT_STEP3_TITLE, 'payment');
                showStep3(data);

                updateStickyButton('step3');

                $('.js-checkout-sticky-button').removeClass('button-loading');
                $('.js-checkout-sticky-button').find('.js-spinner-general').removeClass('spinner-visible');

                $('html, body').delay('fast').animate({scrollTop: 0}, 'fast');
            }
        };

        if ($('.js-pickup-option-radio').is(':checked') && $('.js-service-point-postnummer-input').length && accountNumberInput.length) {
            $.ajax({
                type: 'GET',
                url: Urls.checkoutCheckAccountServiceNumberForPaazl,
                data: {
                    accountServiceNumber: accountNumberInput.val()
                },
                success: function (data) {
                    if (data.valid) {
                        $.ajax(checkoutStep3);
                    } else {
                        $('.js-service-point-postnummer-input-error').removeClass('hide');
                    }
                }
            });
        } else {
            $.ajax(checkoutStep3);
        }
    }

    function showStep3(data) {
        $step1.removeClass('current').removeClass('selected');
        $step1.content.hide().removeClass('open');

        $step2.removeClass('current').removeClass('selected').removeClass('disabled');
        $step2.content.hide().removeClass('open');

        $step3.addClass('current selected');
        $step3.content.show().addClass('open');

        $step3.removeClass('disabled');

        if (data) {
            $step3.content.html(data);
            customSelect.init();
        }

        $currentStep = $step3;

        if (!$('.js-hidden-select').hasClass('js-custom-select')) {
            $('.js-hidden-select').addClass('js-custom-select').selectric();
            if (!isSmallView()) {
                $(document).find('.js-custom-select').attr('tabindex', '-1');
            }
        }

        $('.js-summary').addClass('step3');

        const $selectedPaymentMethod = $('#payment input[type=radio][name=brandCode]:checked').val();
        if (!$selectedPaymentMethod) {
            $('#payment input[type=radio][name=brandCode]:first').prop('checked', true);
        }

        // If Klarna Getting Address is used, Use Klarna Payment Method automatically
        if ($('#js_klarna_valid_address').length > 0 && $('#js_klarna_valid_address').val() == '1') {
            if ($('li.js-klarna input[type="radio"]').length > 0) {
                $('li.js-klarna input[type="radio"]').trigger('click');
            }
        }

        //Copy same regex to payment phone field if exist
        checkPhoneFieldRegex();

        // init validations
        validator.init();

        if ($('.js-ideal').find('input[type=radio]').is(':checked')) {
            $('.js-ideal').find('.js-method-extra').slideDown();
        }

        updateEuroBonusInputField();
    }

    //go to the other step by click on the 'save'/'edit' button
    function jumpToStep($stepOpen, stepIndex, skipHistoryUpdate) {
        processHistoryUpdates(skipHistoryUpdate, stepIndex);

        $currentStep.removeClass('current').removeClass('selected');
        $currentStep.content.removeClass('open').hide();

        $stepOpen.addClass('current selected');
        $stepOpen.content.addClass('open').show();
        if ($stepOpen == $step2) {
            $(document).on('keydown', step2KeyPressHandler);
        } else {
            $(document).off('keydown', step2KeyPressHandler);
        }
    }

    function pay(e) {
        if (!validatePaymentMethod()) {
            e.preventDefault();
        }

        pushCheckoutPaymentMethodEvent();

        $(e.target).addClass('button-loading');
        $(e.target).find('.js-spinner-general').addClass('spinner-visible');

        //check eurobonus code is valid, before submit
        const isChecked = $('[id$=sasEurobonusMember]').is(':checked');
        if (isChecked) {
            const memberCode = $('#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode').val();
            if (memberCode && memberCode.length > 0) {
               e.preventDefault();
               $('.js-eurobonus-dropdown').removeClass('eurobonus-valid');
                validateEurobonusMemberId(memberCode, function() {
                    $('#payment').submit();
                }, null);
            }
        }
    }

    function validatePaymentMethod() {
        return $('#payment').validate().form();
    }

    function paymentMethodChanged() {
        $('#payment').validate().resetForm();
        const selectedMethod = $(this).val();

        $('#issuerId').removeClass('required error');
        $('#dwfrm_billing_paymentMethods_birthday').removeClass('required error');
        $('#dwfrm_billing_paymentMethods_phone').removeClass('required error');

        if (selectedMethod === 'ideal') {
            const $issuer = $('#issuerId');
            $issuer.addClass('required');
        }

        if (selectedMethod === 'klarna') {
            const $dob = $('#dwfrm_billing_paymentMethods_birthday');
            const $phone = $('#dwfrm_billing_paymentMethods_phone');
            $dob.addClass('required');
            $phone.addClass('required');
        }

        if (selectedMethod === 'rituals') {
            $('[id$=sasEurobonusMember]').prop('disabled', true);
            $('[id$=sasEurobonusMember]').prop('checked', false);
            $('.js-eurobonus-dropdown').addClass('hide');
        } else {
            $('[id$=sasEurobonusMember]').prop('disabled', false);
        }

        $('#selectedPaymentMethodID').val(selectedMethod);

        const $methodElement = $('.js-' + selectedMethod);
        if ($methodElement.length > 0) {
            const $extra = $methodElement.children('.js-method-extra');
            $('.js-method-extra').slideUp(animationSpeed);
            if ($extra.length > 0) {
                $extra.slideDown(animationSpeed);
            }
        }
    }

    function checkPhoneFieldRegex() {
        const shippingPhoneFieldRegex = $($('input[name$="_shippingAddress_addressFields_phone"]')).attr('regex');
        if (shippingPhoneFieldRegex !== undefined) {
            $('#dwfrm_billing_paymentMethods_phone').attr('regex', shippingPhoneFieldRegex);
        }
    }

    function idealBankChanged() {
        $('li.js-ideal input[type="radio"]').prop('checked', true);
    }

    function pushCheckoutPaymentMethodEvent() {
        const selectedPaymentMethod = $('#payment input[type=radio][name=brandCode]:checked').val();

        let selectedBank = 'chosen';
        if (selectedPaymentMethod === 'ideal') {
            selectedBank = $('select#issuerId > option:checked').text().trim();
        }

        google.tagManager.pushCheckoutPaymentMethodEvent(selectedPaymentMethod, selectedBank);
    }

    /**
     * @function
     * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
     */
    function updateSummary() {
        const $summary = $('.js-summary');

        // indicate progress
        progress.show($summary);

        // load the updated summary area
        $summary.load(Urls.summaryRefreshURL, function () {
            // hide edit shipping method link
            //miniCart.adjustPricePadding();
            adjustPricePadding();
            damHelper.updateImages($('.js-summary'));
            $summary.fadeIn('fast');
            $summary.find('.checkout-mini-cart .minishipment .header a').hide();
            $summary.find('.order-totals-table .order-shipping .label a').hide();
        });
    }

    function validateEurobonusMemberId(memberId, onSuccess, onError) {
        const $btnValidateEurobonusMember = $('#btnValidateEurobonusMember');
        const $eurobonusError = $('#eurobonusError');
        const $eurobonusBlock = $('.js-eurobonus-dropdown');

        $eurobonusBlock.removeClass('eurobonus-valid');
        $btnValidateEurobonusMember.removeClass('btn-success').addClass('btn-loading');
        $eurobonusError.addClass('hide');

        $.ajax({
            type: 'GET',
            url: Urls.checkoutValidateEurobonusMemberId,
            data: {memberId: memberId},
            success: function(data) {
                if (data && data.isMemberValid) {
                    $btnValidateEurobonusMember.addClass('btn-success');
                    $eurobonusBlock.addClass('eurobonus-valid');
                    $('#validatedEurobonusCode').val(memberId);

                    if (onSuccess) {
                        onSuccess();
                    }
                } else {
                    $eurobonusBlock.removeClass('eurobonus-valid');
                    showInvalidEurobonusMemberCode(onError);
                }
            },
            error: function(){
                showInvalidEurobonusMemberCode(onError);
                $eurobonusBlock.removeClass('eurobonus-valid');
            },
            complete: function() {
                $btnValidateEurobonusMember.removeClass('btn-loading');
            }
        });
    }

    function showInvalidEurobonusMemberCode(onError){
        const $sasEurobonusMemberCode = $('.js-eurobonus-code-input');
        const $eurobonusError = $('#eurobonusError');
        const error = $sasEurobonusMemberCode.data('invalid-code-text');

        $eurobonusError.removeClass('hide').text(error);
        $sasEurobonusMemberCode.addClass('error');

        //TODO: This should be done in validator.js
        //Scroll to the input field and focus, but only if this is the first error
        let allErrors = $('input.error');
        if (allErrors.first().is($sasEurobonusMemberCode)) {
            setTimeout(function() { //Small timeout to avoid conflicting with the validator.js animation
                allErrors = $('input.error'); // refreshing all input errors

                if (allErrors.first().is($sasEurobonusMemberCode)) {
                    $('html, body').animate({
                        scrollTop: $sasEurobonusMemberCode.offset().top - $('.js-header').height() - 30
                    }, 50);
                    $sasEurobonusMemberCode.focus();
                }
            }, 100);
        }

        if (onError) {
            onError();
        }
    }

     function openStep(stepNumber, skipHistoryUpdate) {
        animationSpeed = 0;
        switch (stepNumber) {
            case 2:
                updateStep2(skipHistoryUpdate);
                updateStickyButton('step2');
                break;
            case 3:
                updateStep3(skipHistoryUpdate);
                updateStickyButton('step3');
                break;
            case 1:
            default:
                updateStep1(skipHistoryUpdate);
                updateStickyButton('step1');
                break;
        }
        animationSpeed = 400;
    }

    function showStep(stepNumber) {
        switch (stepNumber) {
            case 2:
                showStep2();
                updateStickyButton('step2');
                break;
            case 3:
                showStep3();
                updateStickyButton('step3');
                break;
            case 1:
            default:
                showStep1();
                updateStickyButton('step1');
                break;
        }
    }

    function updateDeliveryReview(selectedShippingOption) {
        updateOrderTotals(selectedShippingOption.totalPrice);
        updateAddressSummary();
        updateStep2(true);
    }

    function updateOrderTotals(price) {
        $('.js-order-totals .js-order-value').text(price);
        $('.js-checkout-sticky-bar .js-sticky-price-container .order-total-amount').text(price);
    }

    function setHiddenDHLPostNummer(dHLPostNummer) {
        const hiddenDHLPostNummer = $('input.js-dhl-post-nummer');
        hiddenDHLPostNummer.val(dHLPostNummer);
    }

    return {
        init: init,
        updateSummary: updateSummary,
        submitInformationForm: submitInformationForm
    };
};

module.exports = new SinglePageCheckout();
